import { Stack, StackProps, Typography } from '@mui/material';

interface TeamCardProps extends StackProps {
  isSelected: boolean;
  image: string;
  name: string;
}

export const TeamCardList = ({ isSelected = false, image, name, ...rest }: TeamCardProps) => {
  return (
    <Stack
      paddingLeft={{ xs: '0px', sm: '46px' }}
      paddingTop={{ xs: '38px', sm: '0px' }}
      position={'relative'}
      width={'100%'}
      height={'100%'}
      direction={'row'}
      justifyContent={'center'}
      alignItems={'center'}
      sx={{ cursor: 'pointer' }}
      {...rest}>
      {isSelected && (
        <Stack
          left={{ xs: 'unset', sm: 0 }}
          zIndex={10}
          width={0}
          height={0}
          top={{ xs: 0, sm: 'unset' }}
          position={'absolute'}
          sx={{
            borderTop: '14px solid transparent',
            borderBottom: '14px solid transparent',
            borderLeft: '14px solid #FF5319',
            transform: { xs: 'rotate(90deg)', sm: 'unset' },
          }}
        />
      )}
      <Stack width={{ xs: '105px', sm: '100%' }} height={'100%'} position={'relative'}>
        <Stack
          position={'relative'}
          bgcolor={'#FFFFFF0D'}
          minHeight={'100px'}
          alignItems={'center'}
          justifyContent={'center'}
          sx={{
            transition: 'all 0.1s ease-in-out',
            ...(isSelected && {
              boxShadow: '0px 0px 30px 0px #FFFFFF40',
              background:
                'linear-gradient(135deg, rgba(225, 225, 225, 0.85) 0%, rgba(255, 255, 255, 0.05) 25%, rgba(255, 255, 255, 0.05) 50%, rgba(255, 255, 255, 0.05) 75%, rgba(225, 225, 225, 0.85) 100%)',
            }),
            '&:hover': {
              boxShadow: '0px 0px 30px 0px #FFFFFF40',
              background:
                'linear-gradient(135deg, rgba(225, 225, 225, 0.85) 0%, rgba(255, 255, 255, 0.05) 25%, rgba(255, 255, 255, 0.05) 50%, rgba(255, 255, 255, 0.05) 75%, rgba(225, 225, 225, 0.85) 100%)',
            },
          }}>
          <Stack
            top={'3px'}
            left={'3px'}
            width={'calc(100% - 6px)'}
            height={'calc(100% - 6px)'}
            position={'absolute'}
            bgcolor={'#0A0D16'}
          />

          <Stack
            width={'100%'}
            pl={{ xs: '24px', sm: '105px' }}
            pr={{ xs: '24px', sm: '16px' }}
            justifyContent={'center'}
            alignItems={'center'}
            display={{ xs: 'none', sm: 'flex' }}>
            <Typography
              component={'h3'}
              zIndex={10}
              variant={'displayMedium'}
              className={'clip-text'}
              fontSize={{ xs: '20px', sm: '20px' }}
              lineHeight={{ xs: '24px', sm: '22px' }}
              sx={{ background: 'linear-gradient(90deg, #A9A9A9 0%, #FFFFFF 50%, #A9A9A9 100%)' }}>
              {name}
            </Typography>
          </Stack>
        </Stack>
        <Stack
          width={{ xs: '105px', sm: '94px' }}
          height={{ xs: '95px', sm: '95px' }}
          position={'absolute'}
          bottom={0}
          left={{ xs: 0, sm: -10 }}
          zIndex={5}
          sx={{
            background: `url(${image})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        />
      </Stack>
    </Stack>
  );
};
